import type { RichContent } from "components/parts/ParseRichText/types";
export const getReadTimeForRichText = (content: RichContent[]) => {
  if (!content) return "0 min";
  let totalTimeInSeconds = 0;
  let timePerImage = 12;
  const secondsPerWord = 0.22;
  content.forEach((node) => {
    if (
      node.nodeType === "embedded-entry-block" ||
      node.nodeType === "embedded-entry-inline"
    ) {
      if (timePerImage > 3) {
        totalTimeInSeconds += timePerImage;
        timePerImage--;
      } else {
        totalTimeInSeconds += 3;
      }
    } else if (node.nodeType !== "text") {
      node.content.forEach((contentBlock) => {
        const string =
          contentBlock.nodeType === "text"
            ? String(contentBlock.value)
            : "".replace(/^\s+/, "").replace(/\s+$/, "");
        const wordcount = (string.match(new RegExp("\\w+", "g")) || []).length;
        totalTimeInSeconds += wordcount * secondsPerWord;
      });
    }
  });
  const totalTimeInMinutes = totalTimeInSeconds / 60;
  if (totalTimeInMinutes < 0.5) {
    return "less than a minute";
  } else if (totalTimeInMinutes >= 0.5 && totalTimeInMinutes < 1.5) {
    return "1 min";
  }

  return `${Math.ceil(totalTimeInMinutes)} min`;
};
